/**
 * Indique si une description « compte » pour l’UI (pastille, tri, etc.).
 * Garde la même règle que l’optimistic update : texte non vide après trim.
 */
export function hasDescriptionFromText(
  value: string | null | undefined
): boolean {
  return typeof value === 'string' && value.trim().length > 0;
}
